var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58531 17.2307H0.625C0.625 13.3828 3.74563 10.2622 7.59346 10.2622C11.4413 10.2622 14.5619 13.3828 14.5619 17.2307H11.6016",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6512 6.55179C10.6512 8.24094 9.28266 10.2679 7.59351 10.2679C7.13543 10.2679 6.70026 10.119 6.3109 9.8671C5.9788 9.64952 5.68677 9.3804 5.44629 9.06547L5.42911 9.04829C4.86797 8.33255 4.53014 7.40495 4.53014 6.55751C4.53014 5.71008 4.85079 4.9657 5.42911 4.39311C6.00743 3.82052 6.78043 3.49414 7.59351 3.49414C9.28266 3.49414 10.6512 4.86836 10.6512 6.55751V6.55179Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.029 17.2307H21.6908C21.6908 13.3828 24.8115 10.2622 28.6593 10.2622C32.5071 10.2622 35.6277 13.3828 35.6277 17.2307H33.0453",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.717 6.55179C31.717 8.24094 30.3485 10.2679 28.6593 10.2679C28.2013 10.2679 27.7661 10.119 27.3767 9.8671C27.0446 9.64952 26.7526 9.3804 26.5121 9.06547L26.4949 9.04829C25.9338 8.33255 25.596 7.40495 25.596 6.55751C25.596 5.71008 25.9166 4.9657 26.4949 4.39311C27.0733 3.82052 27.8463 3.49414 28.6593 3.49414C30.3485 3.49414 31.717 4.86836 31.717 6.55751V6.55179Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 0.625V22.9561",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62945 17.5164L7.20981 19.0967L9.55171 15.936",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4568 15.936L30.6175 19.0967",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6175 15.936L27.4568 19.0967",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStart);
export default __webpack_public_path__ + "static/media/newStart.d39bca8e28f965822a66f7cd0551d528.svg";
export { ForwardRef as ReactComponent };